module.exports = __webpack_public_path__ + "static/img/logo3.5f62989.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/logo3.png
// module id = un3P
// module chunks = 1